/**
 * Session Filters Component
 * Filter bar for session history
 */
import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Filter } from 'lucide-react';

const SessionFilters = ({ filters, setFilters, filterOptions, onClear }) => {
  return (
    <Card className="mb-6">
      <CardContent className="p-4">
        <div className="flex flex-wrap items-center gap-4">
          <div className="flex items-center gap-2">
            <Filter className="w-4 h-4 text-gray-500" />
            <span className="text-sm font-medium">Filters:</span>
          </div>
          
          <div className="flex items-center gap-2">
            <label className="text-sm text-gray-500">From:</label>
            <Input
              type="date"
              value={filters.startDate}
              onChange={(e) => setFilters({...filters, startDate: e.target.value})}
              className="w-40"
            />
          </div>
          
          <div className="flex items-center gap-2">
            <label className="text-sm text-gray-500">To:</label>
            <Input
              type="date"
              value={filters.endDate}
              onChange={(e) => setFilters({...filters, endDate: e.target.value})}
              className="w-40"
            />
          </div>
          
          <select
            value={filters.observerId}
            onChange={(e) => setFilters({...filters, observerId: e.target.value})}
            className="border rounded-md px-3 py-2 text-sm"
          >
            <option value="">All Observers</option>
            {filterOptions.observers.map(obs => (
              <option key={obs.id} value={obs.id}>{obs.name}</option>
            ))}
          </select>
          
          <select
            value={filters.childId}
            onChange={(e) => setFilters({...filters, childId: e.target.value})}
            className="border rounded-md px-3 py-2 text-sm"
          >
            <option value="">All Children</option>
            {filterOptions.children.map(child => (
              <option key={child.id} value={child.id}>{child.name}</option>
            ))}
          </select>
          
          <Button variant="outline" size="sm" onClick={onClear}>
            Clear Filters
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default SessionFilters;
